var map = {
	"./kirill_tokarev.png": "./app/assets/images/competitions/digital_art/judges/kirill_tokarev.png",
	"./samur_isma.png": "./app/assets/images/competitions/digital_art/judges/samur_isma.png",
	"./stephen_price.png": "./app/assets/images/competitions/digital_art/judges/stephen_price.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images/competitions/digital_art/judges sync recursive ^\\.\\/.*\\.png$";